import { useTheme } from "@/shadcn/components/theme-provider";
import { CircleCheckBig } from "lucide-react";
import React from "react";

type TaskCellStatusProps = {
  className: string;
  completed: boolean;
  taskID: number;
  completeTask: (taskID: number) => void;
  unCompleteTask?: (taskID: number) => void;
  iconClassName?: string;
};

const TaskCellStatus: React.FC<TaskCellStatusProps> = ({
  className,
  completed,
  completeTask,
  unCompleteTask,
  taskID,
  iconClassName,
}) => {
  const { theme } = useTheme();
  function handleClick(e: React.MouseEvent<SVGSVGElement, MouseEvent>) {
    e.stopPropagation();
    // console.log(taskID);
    if (completed) {
      if (!unCompleteTask) return;
      unCompleteTask(taskID);
    } else {
      completeTask(taskID);
    }
  }

  return (
    <div className={className}>
      <CircleCheckBig
        onClick={handleClick}
        className={`cursor-pointer w-5 h-5 ${iconClassName ?? "ms-3"} ${
          completed
            ? "text-green-500"
            : theme === "light"
              ? "text-gray-700"
              : "text-gray-200"
        }`}
        style={{
          transform: "translateY(1px)",
        }}
      />
    </div>
  );
};

export default TaskCellStatus;
